import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types"

import Header from "../header/"
import Footer from "../footer/"
import Seo from "../seo"

import "./style.css"
import "../../styles/colors.css"
import "../../styles/header.css"
import "../../styles/footer.css"
import "../../styles/navbar.css"

import menulist from "../../content/menulist.json"

const Layout = ({
		resizeHandler,
		children,
		pageDescription,
		customClass,
		activePath,
		fullPath,
		lockDisplayType,
		pageImage,
		pageTitle,
		mobileTitle,
		structuredData
	}) => {
	// Remove leading and tailing slashes
	var contentTitle = pageTitle;
	const parentURL = activePath.replace(/^\/|\/$/g, '');
	const fullURL = fullPath.replace(/^\/|\/$/g, '');

	const [dimensions, setDimensions] = useState({
			initDisplayType: true,
			displayType: 3
	  });

	useEffect(() => {
		if (typeof window === 'undefined') return;
		function handleResize() {
			const minwidth = 500;	// in case soft keyboard issue, don't consider as portrait
			if (dimensions.initDisplayType === true || lockDisplayType === false) {
				const newtype = (window.innerHeight<=0) ? 0:
					(window.innerWidth >= minwidth && window.innerWidth/window.innerHeight)>1.5 ? 0:
					(window.innerWidth >= minwidth && window.innerWidth/window.innerHeight)>1 ? 1:		// square
					(window.innerWidth/window.innerHeight)>0.8 ? 2:3									// Portrait
				setDimensions({
					/*
						height: window.innerHeight,
						width: window.innerWidth,
					*/
					initDisplayType: false,
					displayType: newtype
				});
				if (typeof resizeHandler !== 'undefined') {
					resizeHandler(newtype);
				}
			}
		}
		if (dimensions.initDisplayType === true) {
			handleResize();
		}
		window.addEventListener('resize', handleResize)
		return _ => {
			window.removeEventListener('resize', handleResize)
		}
	})

	const getURLTitle = (menuobj, url) => {
		var tmpidx = 0;
		var tmptitle = "";
		while (tmpidx < menuobj.length) {
			if (menuobj[tmpidx].hasOwnProperty("subitems")) {
				// Prioritize sub menu title
				tmptitle = getURLTitle(menuobj[tmpidx].subitems, url);
				if (tmptitle.length > 0) {
					return tmptitle;
				}
			}
			if (menuobj[tmpidx].hasOwnProperty("url") && menuobj[tmpidx].hasOwnProperty("title")) {
				if (menuobj[tmpidx].url === url) {
					return menuobj[tmpidx].title;
				}
			}
			tmpidx = tmpidx + 1;
		}
		return tmptitle;
	}


	const curmenu = menulist;

	if (contentTitle === "") {
		contentTitle = getURLTitle(curmenu, fullURL);
	}

	return <>
			<Seo title={contentTitle} description={pageDescription} image={pageImage} canonicalpath={fullPath} structuredData={structuredData} />
			<Header menulist={curmenu} customClass={customClass} mobileTitle={mobileTitle} initDisplayType={dimensions.initDisplayType} displayType={dimensions.displayType} placeHolder={true} pageTitle={contentTitle} />
			<Header menulist={curmenu} customClass={customClass} mobileTitle={mobileTitle} initDisplayType={dimensions.initDisplayType} displayType={dimensions.displayType} activePath={parentURL} fullPath={fullURL!==''?fullURL:parentURL} pageTitle={contentTitle} />
			<div>
			<main>{children?
				children
			:
				<p className="underconstruction font-size-large">
						{contentTitle} is Under Construction
				</p>
			}</main>
			</div>
			<Footer initDisplayType={dimensions.initDisplayType} displayType={dimensions.displayType} activePath={parentURL} />
		</>
}


Layout.propTypes = {
	children: PropTypes.node,
	pageDescription: PropTypes.string,
	customClass: PropTypes.string,
	activePath: PropTypes.string,
	fullPath: PropTypes.string,
	lockDisplayType: PropTypes.bool,
	pageTitle: PropTypes.string,
	pageImage: PropTypes.string,
	mobileTitle: PropTypes.bool
}


Layout.defaultProps = {
	pageDescription: ``,
	customClass: ``,
	activePath: ``,
	fullPath: ``,
	lockDisplayType: false,	// true to always use Mobile Menu
	pageTitle: ``,
	pageImage: ``,
	mobileTitle: true
}


export default Layout
